import React, { useRef, useEffect } from 'react';
import html2canvas from 'html2canvas';
import agre from "../../assets/images/newStamp.jpg";

const CreateAgreement = ({ user, onImageUrlGenerated }) => {
    const agreementRef = useRef();

    useEffect(() => {
        const generateImage = async () => {
            if (agreementRef.current) {
                const canvas = await html2canvas(agreementRef?.current);
                const imageUrl = canvas.toDataURL('image/png');
                onImageUrlGenerated(imageUrl);
            }
        };

        generateImage();
    }, [user, onImageUrlGenerated]);

    return (
        <div ref={agreementRef} style={{
            position: 'relative',
            width: '600px',
            height: '830px',
            backgroundImage: `url(${agre})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '600px',
        }}>
            <div style={{
                padding: '0 55px',
                fontFamily: 'Helvetica',
                textAlign: 'justify',
                fontSize: '13px',
                lineHeight: '1.6',
                color: '#000000',
                position: 'absolute',
                top: '45%',
            }}>
                <h5 style={{ textAlign: 'center', fontWeight: '600' }}>LEGAL AGREEMENT</h5>
                <p>This Agreement Executed Between {process.env.REACT_APP_COMPANY_NAME},{process.env.REACT_APP_COMPANY_ADDRESS}. Herein After For Brevity's Sake Referred To As Client, Which Expression Shall, Unless Exclude By Or Repugnant To The Context, Be Deemed To Mean And Include Its Permitted Assigns And Successors-in-interest.</p>

                <p>Whereas The Client Is Engaged In The Business Of Outsourcing The Business For The IT And IT Enabled Services Industry And Whereas It Has Entered Into An Agreement With Its <b>{user?.name}</b>, residing at <b>{user?.address}</b>, email <b>{user?.email}</b>, phone <b>{user?.number}</b>, Hereinafter For Brevity's Sake Referred To As Business Associate To Execute The Data Entry Operations Described In Detail In The Scope Of Work, Which Need To Be Executed Through Various Delivery Partners.</p>
            </div>
        </div>
    );
};

export default CreateAgreement;
